class Filters {
	wrapper = null;

	constructor(el) {
		this.wrapper = $( el );
    this.filter_key = $( el ).attr('data-filter');

		if (this.wrapper.length) {
			this.init();
		}
	}

  /*
	init() {
    const obj = this;

    $(".filters-group__list button.tag").on("click", function (e) {
      e.preventDefault();
      $( this ).toggleClass( 'active' );
      obj.getCards();
    });

    $("button.filters-group__reset-btn").on("click", function (e) {
      e.preventDefault();
      $( this ).closest( '.filters-group' ).find( '.filters-group__list button.tag' ).removeClass( 'active' );
      obj.getCards();
    });

	}

	getCards() {
    var business_outcome = $(this.wrapper).find('.filters-group__list.business-outcome button.tag.active').map(function () {
      return $(this).attr('data-slug');
    });

    var organisation = $(this.wrapper).find('.filters-group__list.organisation button.tag.active').map(function () {
      return $(this).attr('data-slug');
    });

    var filter_content_id = this.filter_key;

    $.ajax({
      url: ajaxurl,
      data: {
        action: "service_cards_filter",
        business_outcomes: $.makeArray(business_outcome),
        organisations: $.makeArray(organisation),
      },
      type: "POST",
    }).done((response) => {
      if (response.success) {
        console.info(filter_content_id);
        $('#' + filter_content_id).html(response.data);
      }
    });
	}
  */


init() {
  const obj = this;

  $(".filters-group__list .tag").on("click", function (e) {
    e.preventDefault();
    $(this).toggleClass("active");

    obj.updateResetButtons();
    obj.getCards();
  });

  $(".filters-group__reset-btn").on("click", function (e) {
    e.preventDefault();
    const $group = $(this).closest(".filters-group");
    $group.find(".tag").removeClass("active");

    obj.updateResetButtons();
    obj.getCards();
  });

  this.updateResetButtons(); // Run on load
}


updateResetButtons() {
  $(".filters-group").each(function () {
    const $group = $(this);
    const $activeTags = $group.find(".filters-group__list .tag.active");
    const $resetBtn = $group.find(".filters-group__reset-btn");

    if ($activeTags.length > 0) {
      $resetBtn.fadeIn(); // or use .show() for instant appearance
    } else {
      $resetBtn.fadeOut(); // or use .hide()
    }
  });
}

  getCards() {
  var business_outcome = $(this.wrapper).find('.filters-group__list.business-outcome button.tag.active').map(function () {
    return $(this).attr('data-slug');
  });

  var organisation = $(this.wrapper).find('.filters-group__list.organisation button.tag.active').map(function () {
    return $(this).attr('data-slug');
  });

  var filter_content_id = this.filter_key;
  var $container = $('#' + filter_content_id);
  var $loading = $('.filter-loading-message');

  $loading.show(); // Show loading message

  $.ajax({
    url: ajaxurl,
    data: {
      action: "service_cards_filter",
      business_outcomes: $.makeArray(business_outcome),
      organisations: $.makeArray(organisation),
    },
    type: "POST",
  }).done((response) => {
    if (response.success) {
      $container.html(response.data);
    } else {
      $container.html('<p>No results found.</p>');
    }
  }).fail(() => {
    $container.append('<p>Error loading results.</p>');
  }).always(() => {
    $loading.hide(); // Hide loading message when done
  });
}


  
};

export default Filters;
